import React, { useState, useEffect, Fragment } from 'react';
import { Element } from 'react-scroll';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { ID, STATIC } from '../../../constants';
import { getDataFromResponse, sortByOrderAsc, setErrorStatus } from '../../../utils';
import baseApi from '../../../api/baseApi';
import { ReactComponent as Icon } from '../../../img/readmore-arrow.svg';

import Loader from '../../UI/Loader/Loader';
import Content from '../../Layout/Entry/Content/Content';

const ContactFooter = () => {
    const [isMounted, setIsMounted] = useState(false);
    const [decisionTree, setDecisionTree] = useState(null);
    const [description, setDescription] = useState(null);
    const [error, setError] = useState(false);

    const getContentByTarget = (target) => decisionTree?.steps?.[target]?.content;
    const getChoices = () => decisionTree?.steps?.[decisionTree?.root]?.choices;
    const getSortedChoices = () => {
        const choices = getChoices();
        if (!choices) {
            return null;
        }

        return sortByOrderAsc(choices);
    };

    useEffect(() => {
        setIsMounted(true);
        return () => setIsMounted(false);
    }, []);

    useEffect(() => {
        if (!isMounted) {
            return;
        }

        baseApi.get(`/categories/${STATIC.category}/entries/${STATIC.contactFooter}`)
            .then(getDataFromResponse)
            .then(data => {
                if (!isMounted) {
                    return;
                }

                setDecisionTree(data.decisionTree);
                setDescription(data.description);
            })
            .catch(error => setErrorStatus(setError, error));
    }, [isMounted]);

    if (error || !isMounted) {
        return null;
    }

    const getTabButtons = () => getSortedChoices()?.map(item => (
        <Tab
            key={item?.id}
            className="tabs-section__nav-item"
            selectedClassName="tabs-section__nav-item--selected"
        >
            {item?.title}
            <span className="tabs-section__nav-icon">
                <Icon className="icon icon--xs" aria-hidden="true" />
            </span>
        </Tab>
    ));

    const getTabContent = () => getSortedChoices()?.map(item => (
        <TabPanel
            key={item?.id}
            className="tabs-section__panel"
            selectedClassName="tabs-section__panel--active"
            data-cy="contact-footer-content"
            role="tabpanel"
        >
            <Content content={getContentByTarget(item?.target)} />
        </TabPanel>
    ));

    const descriptionLines = description
        ?.split(/\r\n|\n|\r/gm)
        ?.map(line => <Fragment key={line}>{line}<br /></Fragment>);

    return (
        <Element name={ID.contactFooterId} id={ID.contactFooterId} className="help-footer" data-cy="contact-footer">
            {!decisionTree
                ? <div className="help-footer__loader"><Loader spinner additionalClass="mix-blend-mode-screen" /></div>
                : <div className="help-footer__wrapper">
                    <div className="help-footer__header">
                        <h2 className="help-footer__heading" data-cy="contact-footer-header">
                            {descriptionLines}
                        </h2>
                    </div>
                    <div className="help-footer__content">

                        <Tabs className="tabs-section">
                            <TabList className="tabs-section__nav" data-cy="contact-footer-navigation" role="tablist" aria-orientation="vertical">
                                {getTabButtons()}
                            </TabList>
                            {getTabContent()}
                        </Tabs>
                    </div>
                </div>}
        </Element>
    );
};

export default ContactFooter;
